import { FilterOutlined, PlusOutlined, RedoOutlined } from "@ant-design/icons";
import { Card, Row, Space, Button, Flex, Select, List, message } from "antd";
import { CardContainer } from "components/elements";
import LeaveTypeTable from "components/table/LeaveTypeTable";
import { useTranslation } from "react-i18next";
import { ReactComponent as DownloadIcon } from "../../../assets/icon/downloadIcon.svg";

import styles from "../styles/Attendance.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import AttendenceFilter from "features/attendance/components/AttendenceFilter";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import { Modal } from "antd/lib";
import { getLeaveTypeOptions } from "features/Report/services/reportApi";
import { FormSelect } from "components/form/FormProvide";
import { calNewLeaveBenefitByLeaveTypeList } from "features/employee/services/employeeApi";
import { setIsLoading } from "../slices/attendanceSlice";

const LeaveType = ({
  isLoading = false,
  pagination = {},
  leaveTypeList = [],
  leaveGroupOptions = [],
  onCreate = () => { },
  onStatus = () => { },
  onEdit = () => { },
  onDelete = () => { },
  onChange = () => { },
  onCancel = () => { },
  onSearch = () => { },
}) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [useFilter, setUseFilter] = useState(false);
  const [openModal, setOpenModal] = useState(false)
  const { roles } = useSelector((state) => state.company);
  const [leaveTypeOptions, setLeaveTypeOptions] = useState([])
  const [leaveList, setLeaveList] = useState([])
  const currentCompany = useSelector((state) => state.company.currentCompany);
  const loading = useSelector((state) => state.attendance.isLoading);
  const getLeaveGroupOptions = useCallback(async () => {
    if (typeof currentCompany !== "object") {
      try {
        dispatch(setIsLoading(true));
        const values = {
          companyId: currentCompany,
        };
        const response = await getLeaveTypeOptions(values);
        setLeaveTypeOptions(response.data)
      } catch (error) {
        // Alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    }
  }, [currentCompany]);

  console.log("leaveTypeOptions", leaveTypeOptions);
  useEffect(() => {

    getLeaveGroupOptions()
  }, [])

  const onCalculate = useCallback(async (leaveTypeIds) => {
    console.log(leaveTypeIds);

    try {
      dispatch(setIsLoading(true));
      message.loading(t("common.loading"), 99999)
      await calNewLeaveBenefitByLeaveTypeList({
        companyId: currentCompany,
        leaveTypeIds,
        timeout: 9999999,
        // employeeId: id,
        // year: selectedYear,
      });
      message.destroy()
      message.success(t("common.success"))
      setOpenModal(false)
    } catch (error) {
      console.error('Error calculating leave benefit:', error);
      message.error(t("common.error"))
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany]);

  const callModal = useCallback(
    () => {
      return <Modal
        title={"แจกสิทธิการลา"}
        maskClosable={false}
        open={openModal}
        styles={{
          body: {
            maxHeight: "700px",
            overflowY: "auto",
          }
        }}
        onCancel={() => {
          setOpenModal(false)
        }
        }
        destroyOnClose
        footer={<Row style={{ marginTop: "24px", justifyContent: "end", gap: 12 }}>
          <Button onClick={() => {
            setLeaveList([])
            setOpenModal(false)
          }} style={{ borderRadius: 8, padding: "8px 16px", width: "max-content", height: "max-content" }}>
            {t('action.cancel')}
          </Button>
          <Button type="primary" onClick={() => {
            // callUpload()
            onCalculate(leaveList.map(o => o.id))
          }}
            style={{ borderRadius: 8, padding: "8px 16px", width: "max-content", height: "max-content", backgroundColor: !leaveList.length ? "" : "var(--button-color)" }}
            disabled={!leaveList.length}
          >
            {t('action.submit')}
          </Button>
        </Row>}
        closable={true}
      >
        <div style={{ minHeight: "200px", overflowY: "auto" }}>
          {
            <FormSelect
              // name="under"
              label={t("ประเภทการลา")}
              placeholder={t("กรุณาเลือก")}
              size="large"
              options={(leaveTypeOptions ?? []).map(o => {
                return {
                  value: o?.id,
                  label: o?.name
                }
              })}
              // variant="filled"
              mode="multiple"
              onChange={(e) => {
                console.log("e", e);
                setLeaveList(e);
              }}
            />
          }
        </div>
      </Modal>
    },
    [leaveTypeOptions, openModal, leaveList, loading],
  )



  return (


    <Space className={styles.container} size={24} direction="vertical">
      {callModal()}
      <Row justify="end">
        <Space direction="horizontal" size={12}>
          <Button type="default" onClick={() => { setOpenModal(true) }} style={{ padding: "8px 16px", height: "44px", borderRadius: "8px" }}>
            <Flex align="center" justify="center" gap={8}>
              <RedoOutlined />
              <span style={{ color: "#667085" }}>{t('แจกสิทธิการลา')}</span>
            </Flex>
          </Button>
          <Button type="default" onClick={() => { setUseFilter(!useFilter) }} style={{ padding: "8px 16px", height: "44px", borderRadius: "8px" }}>
            <Flex align="center" justify="center" gap={8}>
              <FilterIcon />
              <span style={{ color: "#667085" }}>{t('othersetting.filter')}</span>
            </Flex>
          </Button>
          {
            roles.includes("CREATE_CONFIGURATION|ATTENDANCE_SETTING|LEAVE_TYPE") && <Button onClick={onCreate} style={{ width: "max-content", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px" }} type="primary">
              <Flex align="center" justify="center" gap={8}>
                <CreateIcon />
                <span>{t('othersetting.create-1')}</span>
              </Flex>
            </Button>
          }

        </Space>
      </Row>
      {useFilter &&
        // (
        //   getPage()
        // )
        <Card style={{ border: "solid 1px #EAECF0" }}>
          <AttendenceFilter
            leaveGroupOptions={leaveGroupOptions}
            onEdit={onEdit}
            dataFlag={"leaveType"}
            onCancel={onCancel}
            onChange={onChange}
            onSubmit={onSearch} />
        </Card>

      }
      {/* <CardContainer width="100%" height="fit-content"> */}
      <LeaveTypeTable
        isLoading={isLoading}
        pagination={pagination}
        dataSource={leaveTypeList}
        onStatus={onStatus}
        onEdit={onEdit}
        onDelete={onDelete}
        onChange={onChange}
      />
      {/* </CardContainer> */}
    </Space>
  );
};

export default LeaveType;
